import { Modal } from "antd";
import styled from "styled-components";


export const SafraModalContainer = styled(Modal)`
 .ant-modal-content {
    padding: 0px;
    bottom: 50px;
  }

  .ant-modal-body {
    padding: 0px;
  }

  .ant-modal-header {
    padding: 0px;
  }

`
export const HeaderSafra = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 15px;

    div {
    width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;
    }

    img {
        width: 140px;
    }
`

export const BodySafra = styled.div`
    width: 100%;
    height: 300px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 15px;
`

export const SafraListContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 10px;
    max-height: 300px;
    overflow-y: auto;
`

export const SafraListItem = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    border-radius: 8px;
    cursor: pointer;
    position: relative;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #D5FFE8;
    }

    &:hover .safra-arrow {
        opacity: 1;
        transform: translateX(0);
        color: #5DA57D;
    }

    .safra-icon {
        width: 32px;
        height: 32px;
        min-width: 32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
    }

    .safra-info {
        display: flex;
        flex-direction: column;
        flex: 1;

        .safra-nome {
            font-weight: 600;
            font-size: 14px;
            color: #1a1a1a;
            margin: 0;
            padding: 0;
        }

        .safra-vigencia {
            font-size: 12px;
            color: #999;
            margin: 0;
            padding: 0;
            line-height: 1.1;
        }
    }

    .safra-arrow {
        opacity: 0;
        transform: translateX(-10px);
        transition: all 0.25s ease;
        color: #999;
        font-size: 14px;
        display: flex;
        align-items: center;
    }
`

export const FooterSafra = styled.div`
    width: 100%;
    display: flex;
    gap: 10px;
    padding: 15px;
`